import Cta from "./Cta";
import HeaderSocials from "./HeaderSocials";

const Header = () => {
  return (
    <header className="header">
      <div className="container header_container">
        <h5>Hello I'm</h5>
        <h1>Amir Ebrahimi</h1>
        <h5 className="text-light">Software Developer</h5>
        <Cta />
        <HeaderSocials />
        <div className="me">
          <img src={`${window.location.origin}/images/me.png`} />
        </div>
        <a href="#footer" className="scroll_down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
